import React from 'react'
// libs
import { useDispatch, useSelector } from 'react-redux'
import { change, formValueSelector } from 'redux-form'
// components
import InputLabel from 'components/FormElements/components/InputLabel'
import { ReduxDatePicker, ReduxRadioGroup } from 'components/FormElements/ReduxForm'
// constants
import { RECURRENCE_ENDS_OPTIONS, RECURRENCE_ENDS_VALUES } from 'constants/index'
// utils
import moment from 'moment'
import { required } from 'utils/index'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const RecurrenceEnds = ({ form }) => {
  const dispatch = useDispatch()
  const selector = formValueSelector(form)

  const { firstPeriodEndsAt, recurrenceEnds, recurrenceEndsAt } = useSelector((state) => ({
    firstPeriodEndsAt: selector(state, `firstPeriodEndsAt`),
    recurrenceEnds: selector(state, `recurrenceEnds`),
    recurrenceEndsAt: selector(state, `recurrenceEndsAt`)
  }))

  React.useEffect(() => {
    if (firstPeriodEndsAt && recurrenceEndsAt && moment(firstPeriodEndsAt).isAfter(moment(recurrenceEndsAt), 'day')) {
      dispatch(change(form, 'recurrenceEndsAt', moment(firstPeriodEndsAt).add(1, 'd')))
    }
  }, [firstPeriodEndsAt])

  return (
    <Wrapper>
      <InputLabel>Recurrence ends</InputLabel>
      <ReduxRadioGroup name={'recurrenceEnds'} options={RECURRENCE_ENDS_OPTIONS} validate={[required]} />
      {recurrenceEnds === RECURRENCE_ENDS_VALUES.ON && (
        <ReduxDatePicker
          validate={required}
          name={'recurrenceEndsAt'}
          label={'End of recurrence'}
          minDate={moment(firstPeriodEndsAt)}
        />
      )}
    </Wrapper>
  )
}

export default RecurrenceEnds
